<div>
  <div bsModal #childModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header" *ngIf="header">
          <h4 id="dialog-child-name" class="modal-title pull-left">{{ header }}</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="text-align: center">
          <p *ngIf="message">{{ message }}</p>
          <div *ngIf="messageHtml" [innerHTML]="messageHtml" class="messageHTML"></div>
          <button type="button" class="btn btn-primary aru" (click)="confirm()">Confirm</button>
          <button type="button" class="btn btn-default aru" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
